import React, { useState } from "react";
import { useTranslation } from "react-i18next"; // أضف هذا الـ import للترجمة
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Select from "../../../components/ui/Select";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation(); // استخدم useTranslation للترجمة
  const [reassignCategoryId, setReassignCategoryId] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const handleConfirm = async () => {
    setIsProcessing(true);

    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleClose = () => {
    setReassignCategoryId("");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-elevation-3 w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-md bg-error/10 flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-error" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">
                حذف منتج
              </h2>
              <p className="text-sm text-muted-foreground">
                {t("deleteActionIrreversible")}
              </p>
            </div>
          </div>

          <Button
            variant="ghost"
            size="icon"
            onClick={handleClose}
            disabled={isProcessing}
          >
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="bg-error/10 border border-error/20 rounded-md p-4">
            <div className="flex items-start space-x-3">
              <Icon
                name="Trash2"
                size={20}
                className="text-error flex-shrink-0 mt-0.5"
              />
              <div>
                <p className="text-sm text-error/80">
                  هل أنت متأكد من أنك تريد حذف المنتج !! هذا الإجراء لا يمكن
                  التراجع عنه
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border gap-4">
   

          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isProcessing}
            loading={isProcessing}
            iconName="Trash2"
            iconPosition="left"
          >
            {t("delete")}
          </Button>

                 <button
            variant="outline"
            onClick={handleClose}
            disabled={isProcessing}
          >
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
